import React, { useEffect, useRef, useCallback, useMemo, useImperativeHandle } from 'react';
import './index.scss';
import styles from './mailList.module.scss';
import { apiHolder as api, inWindow, apis, locationHelper } from 'api';
import MailCardList from '../../common/components/vlist/MailCardList/MailCardList';
import MailCardLong, { getCardHeight } from '../../common/components/vlistCards/MailCard/MailCardLong';
import { FLOLDER } from '../../common/constant';
import { CardOperRedFlag, CardOperFollowUp } from '../../common/components/vlistCards/MailCard/defaultComs';
import ListLoading from '../../common/components/ListLoading/index';
import HotKeys from '../../common/components/HotKeys/HotKeysMult';
import HotKeysLongMult from '../../common/components/HotKeys/HotKeysLongMult';
import { ModuleHotKeyEvent } from '../ListHotKeys/moduleHotKey';
import { getMailKey, scanMailsSetTimeGradients, isMainAccount, folderIdIsContact, systemIsWindow, folderIdIsAllFolder, parseFidFromAllFid } from '../../util';
import useState2RM from '../../hooks/useState2ReduxMock';
import { LIST_MODEL, TASK_MAIL_STATUS } from '../../common/constant';
import { useAppSelector } from '@web-common/state/createStore';
import { isMailDiff } from '@web-mail/utils/mailCompare';
import { renderContacts } from '@web-mail/common/components/vlistCards/MailCard/defaultComs';
import { getIn18Text } from 'api';
import useMailListHotkeys from './useMailListHotkeys';
import useCreateCallbackForEvent from '@web-common/hooks/useCreateCallbackForEvent';
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const eventApi = api.api.getEventApi();
const systemApi = api.api.getSystemApi();
const mailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const VoidCom = () => React.createElement(React.Fragment, null);
const defaultList = [];
const defaultCallback = () => { };
const MailListLong = (props, ref) => {
    const { onContextMenu, onDragStart, onDragEnd, onDoubleClick, onActiveInWindow, hkDisabled, onSelect, onUnSelect, beforeSelected, onActive, customerLabelAfter = null, data, loadMoreRows, rowCount, listHeight, listWidth, scrollTop, listLoading, notice, tagName, isSearching, activeId = defaultList, refreshPage, topExtraData = defaultList, forCustomer = false, showGroupDecorate = true, checkable = true, showCheckbox = true, total, batchSize, threshold, scrollingResetTimeInterval, overscanRowCount, pullRefreshLoadingHeight, loadMoreLoadingHeight, rowHeight, onScroll, noMoreRender, pullRefreshRender, loadMoreLoadingRender, noRowsRenderer, onPullRefresh, onLoadMore, loadMoreLoadingFailRender, onDelete, mailCardDesc, listFouceRender, listModel = LIST_MODEL.INIT, onListModelChange = defaultCallback, selected, selectedKeys, useRealList = false, forceShowAttachment = false, realListClassName = '', realListPager = null, useLeftRightHotKey = false, isRefresh, onContentInsufficientHeight, from, onGroupCollapse, groupCollapse, showSuborbinateFrom = false, } = props;
    const isCorpMail = useMemo(() => {
        return forCustomer && systemApi.getIsCorpMailMode();
    }, [forCustomer]);
    const [showAvator] = useState2RM('configMailListShowAvator', 'doUpdateConfigMailListShowAvator');
    const scrollTopRef = useRef(0);
    const ListHotKeys = useMemo(() => {
        if (useLeftRightHotKey) {
            return HotKeys(MailCardList, ModuleHotKeyEvent);
        }
        return HotKeysLongMult(MailCardList, ModuleHotKeyEvent);
    }, [useLeftRightHotKey]);
    const listCanDrag = useCallback(() => {
        if (isSearching) {
            return false;
        }
        if (folderIdIsAllFolder(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id)) {
            return false;
        }
        const fid = selectedKeys.id;
        const staticForbidRule = [FLOLDER.DRAFT, FLOLDER.WAITINGISSUE, FLOLDER.READYISSUE];
        const res = !staticForbidRule.some(item => item === fid);
        return res;
    }, [isSearching, selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id]);
    const mailCanDrag = useCallback(mail => {
        if (mail) {
            const { taskInfo } = mail;
            return (taskInfo === null || taskInfo === void 0 ? void 0 : taskInfo.status) !== TASK_MAIL_STATUS.PROCESSING;
        }
        return true;
    }, []);
    const handleReadFlagClick = useCallback((data) => {
        const { mark, threadMessageIds, id } = data.entry || {};
        eventApi.sendSysEvent({
            eventName: 'mailStatesChanged',
            eventData: {
                mark: mark === 'none',
                id: isCorpMail && threadMessageIds && threadMessageIds.length ? threadMessageIds : id,
                type: 'redFlag',
            },
            _account: data._account,
            eventStrData: mark === 'none' ? 'mark' : 'unmark',
        });
    }, []);
    const CardOperRedFlagWrap = useCallback((_props) => (React.createElement("span", { onClick: e => {
            e.stopPropagation();
            handleReadFlagClick(_props.data);
        } },
        React.createElement(CardOperRedFlag, Object.assign({}, _props)))), [handleReadFlagClick]);
    const handleFollowUpClick = useCallback((data) => {
        const { _account } = data;
        const { mark, id, isFollowUp } = data.entry || {};
        eventApi.sendSysEvent({
            eventName: 'mailMenuOper',
            eventData: {
                ids: [id],
                accounts: [_account],
                mark: !isFollowUp,
            },
            eventStrData: 'markProcessFollow',
            _account,
        });
    }, []);
    const CardOperFollowUpWrap = useCreateCallbackForEvent((_props) => (React.createElement("span", { style: { marginRight: 3 }, onClick: e => {
            e.stopPropagation();
            handleFollowUpClick(_props.data);
        } },
        React.createElement(CardOperFollowUp, Object.assign({}, _props)))));
    const CustomMailCard = useCallback((_props) => {
        var _a, _b;
        const key = selectedKeys && selectedKeys.id;
        const showReadFlag = !(key === FLOLDER.DELETED || key === FLOLDER.SPAM);
        const showFollowUp = process.env.BUILD_ISEDM && [FLOLDER.CUSTOMER_UNFOLLOW, FLOLDER.UNFOLLOW].some(id => id == parseFidFromAllFid(key));
        const isTask = ((_a = _props === null || _props === void 0 ? void 0 : _props.data) === null || _a === void 0 ? void 0 : _a.taskId) != null;
        const isTpMail = (_b = _props === null || _props === void 0 ? void 0 : _props.data) === null || _b === void 0 ? void 0 : _b.isTpMail;
        const isShowCheckBox = typeof showCheckbox == 'function' ? showCheckbox(_props === null || _props === void 0 ? void 0 : _props.data) : showCheckbox;
        const data = useAppSelector(state => {
            var _a, _b, _c, _d;
            if ((_a = state === null || state === void 0 ? void 0 : state.mailReducer) === null || _a === void 0 ? void 0 : _a.mailEntities) {
                return (_b = state === null || state === void 0 ? void 0 : state.mailReducer) === null || _b === void 0 ? void 0 : _b.mailEntities[(_d = (_c = _props === null || _props === void 0 ? void 0 : _props.data) === null || _c === void 0 ? void 0 : _c.entry) === null || _d === void 0 ? void 0 : _d.id];
            }
        }, (old, newValue) => {
            return !isMailDiff(old, newValue);
        });
        return (React.createElement(MailCardLong, Object.assign({}, _props, { data: data || (_props === null || _props === void 0 ? void 0 : _props.data), forceShowAttachment: forceShowAttachment, showSuborbinateFrom: showSuborbinateFrom, customerLabelAfter: customerLabelAfter, desc: mailCardDesc, summaryExtra: showReadFlag && !isTask && !isTpMail ? CardOperRedFlagWrap : isTpMail ? null : VoidCom, summaryFollowUp: showFollowUp && !isTask && !isTpMail ? CardOperFollowUpWrap : isTpMail ? null : VoidCom, hideTag: tagName, isMultiple: listModel == LIST_MODEL.MULTIPLE, showAvator: showAvator, showCheckbox: isShowCheckBox, from: from })));
    }, [selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id, tagName, listModel, mailCardDesc, showAvator, showCheckbox, CardOperRedFlagWrap, from, showSuborbinateFrom]);
    const defaultOnMailDrag = useCallback((event, item) => {
        event.dataTransfer.effectAllowed = 'move';
        event.dataTransfer.setData('accountId', `${item === null || item === void 0 ? void 0 : item._account}`);
        event.dataTransfer.setData('isThread', `${item === null || item === void 0 ? void 0 : item.isThread}`);
        if (activeId.includes(item.entry.id)) {
            event.dataTransfer.setData('text', activeId);
        }
        else {
            event.dataTransfer.setData('text', item.entry.id);
        }
    }, [activeId]);
    const handleMailDragStart = useCallback((event, item, index) => {
        defaultOnMailDrag(event, item);
        onDragStart && onDragStart(event, item, index);
    }, [onDragStart, defaultOnMailDrag]);
    const mailSenderGroupDecorate = useMemo(() => {
        return (data, preIndex) => {
            try {
                if (data && data.length) {
                    const decorateList = [];
                    let start = renderContacts(data[preIndex]);
                    let startIndex = preIndex;
                    for (let i = preIndex + 1; i < data.length; i++) {
                        if (renderContacts(data[i]) != start || i == data.length - 1) {
                            decorateList.push({
                                key: start,
                                content: `${start} (${i - startIndex})`,
                                isFoldable: true,
                                isCheckable: true,
                                index: startIndex,
                                height: 36,
                                position: 'top',
                                fixed: {
                                    height: 27 + 5,
                                },
                            });
                            start = renderContacts(data[i]);
                            startIndex = i;
                        }
                    }
                    if (startIndex == data.length - 1 && start != renderContacts(data[data.length - 1])) {
                        decorateList.push({
                            key: start,
                            content: `${start} (1)`,
                            index: startIndex,
                            isCheckable: true,
                            isFoldable: true,
                            height: 36,
                            position: 'top',
                            fixed: {
                                height: 27 + 5,
                            },
                        });
                    }
                    return decorateList;
                }
            }
            catch (e) {
                console.error('[mailSenderGroupDecorate Error]', e);
                return null;
            }
            return null;
        };
    }, []);
    const mailGroupDecorate = useMemo(() => {
        const isTaskFlolder = (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) === FLOLDER.TASK;
        let list = [];
        if (isMainAccount(selectedKeys.accountId)) {
            const isVirtualFolder = Number.isInteger(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) ? (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) < 0 : false;
            if (selected == 'ALL' && !folderIdIsContact(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) && !isVirtualFolder && !folderIdIsAllFolder(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id)) {
                list.push((data, preIndex) => {
                    if (data && data.length) {
                        let topSum = 0;
                        let hasTop = false;
                        for (let i = preIndex; i < data.length; i++) {
                            if (data[i].entry.top) {
                                topSum += 1;
                                hasTop = true;
                            }
                            else {
                                break;
                            }
                        }
                        if (hasTop) {
                            return [
                                {
                                    key: 'top',
                                    content: getIn18Text('ZHIDING') + '  ' + topSum + '封',
                                    isFoldable: true,
                                    isCheckable: true,
                                    index: preIndex,
                                    height: 36,
                                    position: 'top',
                                    fixed: {
                                        height: 27 + 5,
                                    },
                                },
                                {
                                    key: 'top-null',
                                    element: React.createElement(React.Fragment, null),
                                    index: preIndex + topSum - 1,
                                    height: 0,
                                    position: 'bottom',
                                    ignore: true,
                                },
                            ];
                        }
                    }
                    return null;
                });
            }
        }
        if (isMainAccount(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.accountId)) {
            if (['ORDER_BY_SENDER_CAPITAL_DESC', 'ORDER_BY_SENDER_CAPITAL_ASC', 'ORDER_BY_RECEIVER_CAPITAL_DESC', 'ORDER_BY_RECEIVER_CAPITAL_ASC'].includes(selected)) {
                list.push(mailSenderGroupDecorate);
            }
        }
        if (!isTaskFlolder &&
            (selected == 'ALL' || selected == 'REDFLAG' || selected == 'UNREAD' || selected == 'COLLEAGUE' || selected == 'ME' || selected == 'SEND' || selected == 'RECEIVE')) {
            list.push((data, fromIndex = 0) => {
                const timeHashes = scanMailsSetTimeGradients(data, fromIndex, checkable);
                return timeHashes;
            });
        }
        return list;
    }, [selectedKeys, selected, checkable]);
    const listRef = useRef();
    useEffect(() => {
        var _a;
        if (scrollTop == 0 && scrollTop != scrollTopRef.current) {
            (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.scrollToPosition(scrollTop);
            scrollTopRef.current = scrollTop;
        }
    }, [scrollTop]);
    const getCardItemHeight = (data) => {
        return getCardHeight(data, forceShowAttachment, showSuborbinateFrom);
    };
    useMailListHotkeys({
        data,
        activeId,
        onActiveInWindow,
        hkDisabled,
        onDelete,
    });
    const ListWidthClassName = useMemo(() => {
        if (process.env.BUILD_ISEDM && listWidth != null) {
            const res = ['wm-long-list-wrap'];
            if (listWidth >= 1626) {
                res.push('mail-llist-long-w-1626');
            }
            return res.join(' ');
        }
        return '';
    }, [listWidth]);
    const ListElement = useMemo(() => {
        return (React.createElement(ListHotKeys, { onSelect: onSelect, onUnSelect: onUnSelect, onActive: onActive, beforeSelected: beforeSelected, hkDisabled: hkDisabled, ref: listRef, className: `${systemIsWindow() ? 'u-vlist-win' : 'u-vlist'} ${ListWidthClassName} mail-long-list-wrap`, containerStyle: {
                marginTop: selectedKeys && selectedKeys.id === FLOLDER.DEFAULT && notice ? 0 : '12px',
            }, style: inWindow() && !locationHelper.isMainPage()
                ? {
                    overflowX: 'hidden',
                    height: '95vh',
                }
                : {
                    overflowX: 'hidden',
                }, height: listHeight, card: CustomMailCard, rowHeight: getCardItemHeight, width: listWidth, onLoadMore: start => loadMoreRows({ startIndex: start }), scrollTop: scrollTop, batchSize: 100, threshold: 500, cardMargin: 1, data: data, total: rowCount, useRealList: useRealList, realListPager: realListPager, realListClassName: realListClassName, getUniqKey: getMailKey, onPullRefresh: refreshPage, activeId: activeId, isRefresh: isRefresh, onScroll: arg => {
                scrollTopRef.current = arg === null || arg === void 0 ? void 0 : arg.scrollTop;
                onScroll && onScroll(arg);
            }, onDoubleClick: (keys, data, index, event) => {
                onDoubleClick && onDoubleClick(data, index, event);
            }, onContextMenu: (keys, data, index, event) => {
                onContextMenu && onContextMenu(keys, data, index, event);
            }, draggable: listCanDrag() && mailCanDrag, onDragStart: (e, data, index) => {
                handleMailDragStart(e, data, index);
            }, onDragEnd: onDragEnd, cardGroupDecorate: showGroupDecorate ? mailGroupDecorate : null, topExtraData: isMainAccount(selectedKeys.accountId) ? topExtraData : null, selectModel: listModel, onListModelChange: (model, activeIds) => {
                if (selectedKeys.id == FLOLDER.TASK) {
                    if (model === LIST_MODEL.INIT) {
                        onListModelChange && onListModelChange(model);
                    }
                }
                else {
                    if (model === LIST_MODEL.INIT) {
                        onListModelChange && onListModelChange(model);
                    }
                    else if (activeIds && (activeIds === null || activeIds === void 0 ? void 0 : activeIds.length) > 0) {
                        onListModelChange && onListModelChange(model);
                    }
                }
            }, isMultiple: listModel == LIST_MODEL.MULTIPLE, scrollingResetTimeInterval: scrollingResetTimeInterval, overscanRowCount: overscanRowCount, pullRefreshLoadingHeight: pullRefreshLoadingHeight, loadMoreLoadingHeight: loadMoreLoadingHeight, noMoreRender: noMoreRender, pullRefreshRender: pullRefreshRender, loadMoreLoadingRender: loadMoreLoadingRender, noRowsRenderer: noRowsRenderer, loadMoreLoadingFailRender: loadMoreLoadingFailRender, listFouceRender: listFouceRender, onContentInsufficientHeight: onContentInsufficientHeight, onGroupCollapse: onGroupCollapse, groupCollapse: groupCollapse, decoratesWrapClassName: styles.mlDecoratesCollapseWrap }));
    }, [
        notice,
        onSelect,
        onUnSelect,
        onActive,
        beforeSelected,
        hkDisabled,
        data,
        selectedKeys,
        listHeight,
        listWidth,
        CustomMailCard,
        getCardHeight,
        loadMoreRows,
        rowCount,
        getMailKey,
        refreshPage,
        activeId,
        onDoubleClick,
        onContextMenu,
        listCanDrag,
        mailCanDrag,
        handleMailDragStart,
        showGroupDecorate,
        mailGroupDecorate,
        topExtraData,
        listModel,
        total,
        batchSize,
        threshold,
        scrollingResetTimeInterval,
        overscanRowCount,
        pullRefreshLoadingHeight,
        loadMoreLoadingHeight,
        rowHeight,
        onScroll,
        noMoreRender,
        pullRefreshRender,
        loadMoreLoadingRender,
        noRowsRenderer,
        onPullRefresh,
        onLoadMore,
        loadMoreLoadingFailRender,
        useRealList,
        onListModelChange,
        listFouceRender,
        useLeftRightHotKey,
        isRefresh,
        onContentInsufficientHeight,
        onGroupCollapse,
        groupCollapse,
        ListWidthClassName,
    ]);
    const currentPageSize = useAppSelector(state => state.mailReducer.realListCurrentPageSize);
    useImperativeHandle(ref, () => listRef.current, []);
    return (React.createElement("div", { className: 'mail-list' + (!useRealList ? ' sirius-no-drag' : '') },
        ListElement,
        useMemo(() => {
            return listLoading && React.createElement(ListLoading, { loading: listLoading, isUseRealList: useRealList, pageSize: currentPageSize });
        }, [listLoading, useRealList, isSearching])));
};
export default React.forwardRef(MailListLong);
